import { BaseModel } from "model/BaseModel";
import Deposito from "model/suprimentos/Deposito";
import ComponenteOP from "./ComponenteOP";
import { BaseEditModel } from "model/BaseEditModel";
import EstoqueLote from "model/suprimentos/EstoqueLote";

export default class LoteComponenteOP implements BaseEditModel {

    id: number;
    codigo: string | null = "";
    key: string | null;
    sequencial: number | null;
    estoqueLote: EstoqueLote;
    qtUtilizada: number;
    componenteOP: ComponenteOP;

    constructor(
        id: number = 0,
        key: string = "",
        sequencial: number = 0,
        estoqueLote: EstoqueLote = new EstoqueLote(),
        qtUtilizada: number = 0,
        componenteOP: any = new ComponenteOP(),
    ) {
        this.id = id;
        this.key = key;
        this.sequencial = sequencial;
        this.estoqueLote = estoqueLote;
        this.qtUtilizada = qtUtilizada;
        this.componenteOP = componenteOP;
    }
}